function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M30.5 35c0 0-2 2-5.5 2s-5.5-2-5.5-2M41.5 35c0 0-2 2-5.5 2s-5.5-2-5.5-2M47 37c-3.5 0-5.5-2-5.5-2M19.5 35c0 0-2 2-5.5 2s-5.5-2-5.5-2M8.5 35c0 0-2 2-5.5 2M30.5 41c0 0-2 2-5.5 2s-5.5-2-5.5-2M41.5 41c0 0-2 2-5.5 2s-5.5-2-5.5-2M47 43c-3.5 0-5.5-2-5.5-2M19.5 41c0 0-2 2-5.5 2s-5.5-2-5.5-2M8.5 41c0 0-2 2-5.5 2M30.5 29c0 0-2 2-5.5 2s-5.5-2-5.5-2M41.5 29c0 0-2 2-5.5 2s-5.5-2-5.5-2M47 31c-3.5 0-5.5-2-5.5-2M19.5 29c0 0-2 2-5.5 2s-5.5-2-5.5-2M8.5 29c0 0-2 2-5.5 2"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M40 22c-2.757 0-5-2.244-5-5.002C35 14.242 37.243 12 40 12s5 2.242 5 4.998C45 19.756 42.757 22 40 22zM11.339 17.685l10.197-5.086 3.206 5.103-14.662 8.758c.191.119.375.253.541.419C10.642 26.896 11.852 28 14 28c2.15 0 3.361-1.106 3.412-1.153l.311-.247c1.177-.886 2.837-.782 3.898.279C21.642 26.896 22.852 28 25 28c2.15 0 3.361-1.106 3.412-1.153l.318-.252c1.188-.882 2.833-.772 3.89.283.012.011.423.372 1.16.682l.871-1.875c.226-.526.344-1.085.349-1.661.006-.826-.224-1.633-.661-2.324L25.62 7.82C24.877 6.678 23.627 6 22.268 6c-.02 0-.04 0-.06 0-.583.009-1.146.141-1.714.414L8.661 12.315C7.609 12.84 7.001 13.899 7 15c0 .451.101.908.315 1.339C7.84 17.391 8.899 17.999 10 18 10.451 18 10.908 17.9 11.339 17.685z"
});

function SvgSwimming(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwimming);
export default __webpack_public_path__ + "static/media/swimming.e36d364f.svg";
export { ForwardRef as ReactComponent };